import React, { useEffect, useState } from "react";
import Back from "../../../components/back";
import Input from "../../../components/input";
import Button from "../../../components/button";
import useRequest from "../../../components/hooks/use-request";
import { ReactComponent as DownloadIcon } from "../../../assets/download.svg";
import { useNavigate, useParams } from "react-router-dom";
import { showToast } from "../../../components/toast";
import { CircleLoader } from "react-spinners";

const PaymentDetails = ({ title, value }: any) => {
  return (
    <div className="flex justify-between mt-3">
      <h3 className="font-normal text-[14px]">{title}</h3>
      <h3 className="font-medium text-[14px] pt-1">{value}</h3>
    </div>
  );
};

const PaymentRequest = () => {
  const navigate = useNavigate()
  const {id} = useParams()
  const [payementDetails, setPaymentDetails] = useState<any>({});

  const { makeRequest: getPaymentRequest } = useRequest(
    `/transactions/${id}/release-details`,
    "GET"
  );
  const { makeRequest: resendReleaseCode, loading: releaseCodeLoading } = useRequest(
    `/transactions/${payementDetails?.order?.orderId}/resend-release-code`,
    "PUT"
  );
  const { makeRequest: approvePayment, loading: approvalLoading } = useRequest(
    `/transactions/${payementDetails?.order?.orderId}/approve`,
    "PUT"
  );

  const handleApprovePayment = async() => {
    const [response] = await approvePayment({ code: payementDetails?.order?.code })
    if (response?.message === 'Transaction approved') {
      navigate("/transactions")
      showToast(response?.message || "Request approved successfully", true, { position: "top-center" });
    } else {
      showToast(response?.message || "Error approving request", false, { position: "top-center" });
    }
  }

    const handleReleaseCode = async() => {
      const [response] = await resendReleaseCode()
      if (response.message == 'Release code sent to buyer') {
       showToast(response.message, true, { position: "top-center" });
      } else {
         showToast("Error sending code", false, { position: "top-center" });
      }
    }

    useEffect(() => {
      const fetchData = async () => {
        if (id) {
          const [response] = await getPaymentRequest();
          setPaymentDetails(response.data || {});
        }
      };
  
      fetchData();
    }, [id]);

  return (
    <>
      <div className="flex gap-5 mt-5">
        <Back />
        <h2 className="text-[24px] font-bold">Release Funds</h2>
      </div>
      <div className=" bg-white border border-[#fff] h-[500px] mt-10 pt-14 rounded-lg mr-10">
        <div className="w-[30%] mx-auto">
          <h2 className="text-[18px] font-semibold">release Funds</h2>
          <Input
            label="Code from buyer"
            className="mt-3"
            placeholder="-"
            value={payementDetails?.order?.code}
            readOnly
          />

          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Proof of delivery from merchant
            </label>
            <div className="flex items-center justify-between p-4 px-6 bg-blue-100 rounded-md">
              <div>
                <p className="text-sm font-medium text-blue-900">
                  {payementDetails?.proof?.proof?.[0]
                    ? payementDetails.proof.proof[0].split("/").pop()
                    : "No file available"}
                </p>
              </div>
              <a
                href={payementDetails?.proof?.proof?.[0]}
                target="_blank" 
                rel="noopener noreferrer"
                download
                className="text-blue-700 hover:text-blue-900"
              >
                <DownloadIcon />
              </a>
            </div>
          </div>
        
            <Button
              size="lg"
              variant="secondary"
              type="submit"
              className="text-[12px] mt-4 cursor-pointer"
              onClick={() => handleReleaseCode()}
            >
            {releaseCodeLoading ? (
              <CircleLoader color="#ffffff" loading={releaseCodeLoading} size={20} />
            ) : (
              "  Resend release code to buyer"
            )}
            </Button>
         
          <Button size="lg" variant="secondary" type="button" 
            className="mt-4 bg-blue-900 text-white cursor-pointer hover:bg-blue-700"
             onClick={() => handleApprovePayment()}
             >
            {approvalLoading ? (
              <CircleLoader color="#ffffff" loading={approvalLoading} size={20} />
                ) : (
                  " Approve"
                )}
            </Button>
         
        </div>
      </div>
    </>
  );
};

export default PaymentRequest;
